/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useArticleSearchHandlers } from '../../../../context';

const style: ouiStyle.InStyle = {
  widthLines: 'full',
  paddingHorizontal: 'simple',
  color: ouiStyle.Constants.Colors.primary,
  paddingVertical: 'simple',
};

const css = ouiStyle.makeCss(style);

export const ArticleSearchInputContent = (props: {
  id: string,
}) => {
  const {
    id,
  } = props;
  const [search, setSearch] = useArticleSearchHandlers();
  const {
    _,
  } = useLingui();
  return (
    <input
      id={id}
      name={id}
      css={css}
      placeholder={_(msg`Rechercher`)}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  );
};
